"use client";

import dynamic from "next/dynamic";

export default dynamic(() => import("./NewEventMobileSlider"), {
  ssr: false,
  loading: () => null,
});
